export const DISTRIBUTIONS_DOCS_LINK =
    "https://docs.snap.com/lens-studio/references/guides/publishing/submission-guidelines#lens-content-requirements";

export const CREATOR_REWARDS_DAYS_THRESHOLD = 90;
export const CREATOR_REWARDS_POSTERS_THRESHOLD = 15_000;
export const CREATOR_REWARDS_DOCS_LINK =
    "https://docs.snap.com/lens-studio/references/guides/publishing/lens-creator-rewards";
export const CREATOR_REWARDS_FAQ_LINK =
    "https://docs.snap.com/lens-studio/references/guides/publishing/lens-creator-rewards#frequently-asked-questions";
export const THRESHOLD_CUTOFF_DATE = new Date("2024-06-01T00:00:00Z");

export const LENS_DESCRIPTION_MAX_CHARS = 160;

export const LENS_RELEASE_NOTE_MAX_CHARS = 100;
